import { render } from "./FormattedTask.vue?vue&type=template&id=99fb340e&scoped=true"
import script from "./FormattedTask.vue?vue&type=script&lang=js"
export * from "./FormattedTask.vue?vue&type=script&lang=js"

import "./FormattedTask.vue?vue&type=style&index=0&id=99fb340e&lang=scss&scoped=true"

import exportComponent from "/home/docker/toodles/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99fb340e"]])

export default __exports__